// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"7f047016","152":"498ee4dd","170":"1ad65af9","404":"2e40c893","415":"e2ed75f0","417":"5c0983c3","488":"c82b92df","691":"51fb3503","872":"48aae835","915":"74e2f11e","935":"c89ee341","973":"5b8f81a8","981":"50e7ad83"}[chunkId] + ".chunk.js";
};